import React from "react";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { colors } from "style";
import { useAIRoleBuilderTasksContext } from "hooks";

/**
 * AIRoleBuilderTasksTitle
 */
const AIRoleBuilderTasksTitle = (props) => {
  const { tasks, loading } = useAIRoleBuilderTasksContext();

  return (
    <span {...props}>
      <FormattedMessage
        id="AIRoleBuilder.Tasks.Title"
        values={{ count: !loading && <span css={styles.count}>({tasks?.length || 0})</span> }}
      />
    </span>
  );
};

const styles = {
  count: css`
    font-weight: 300;
    color: ${colors.grayAnatomyLight1};
  `,
};

export default AIRoleBuilderTasksTitle;
